export default "__VITE_ASSET__DUnCYGaw__"